import React from 'react'
import c from './Loader.module.css'

const Loader = props => (
  <div className={c.center}>
    <div className={c.Loader}>
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  </div>

)

export default Loader
